module.exports = __webpack_public_path__ + "static/img/GYWM-12.86535f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/GYWM-12.jpg
// module id = PT9v
// module chunks = 1